var userData = {
    user_detail: {}
};
var authenticated = false;


export default {
    userData,
    authenticated,
    state_notifications_count: 0,
    state_notifications: {},
    state_setting: {},
    state_bank_accounts: [],
    state_wallets: [],

    sidebarState: false,
    stateLoading: false,

    user_number: null,
    user_email: null,
    guest_number: null,

    state_prices: null,
    realTime_prices: {},
}